import CommonUtil from "../../../../utils/CommonUtil";
import { constants } from "../../../../utils/Constants";
import PageComponent from "../PageComponent";

class SubControlComponent extends PageComponent {
  constructor(props) {
    super(props);

    this.state = this.initialState(this.state);

    this.resetFlags = {};
  }

  setResetFlags = flagsValue => {
    var flags = {};

    for (let i = 0; i < this.getSubArraysPaths().length; i++) {
      flags[this.getSubArraysPaths()[i]] = flagsValue;
    }

    return flags;
  };

  initialState = state => {
    return {
      ...state,
      entity: {}
    };
  };

  componentDidMount() {
    super.componentDidMount();
    this.resetFlags = this.setResetFlags(true);
  }

  _elementExists = (array, element) => {
    return (
      array.filter(arrayElement => {
        return this.subArrayUniqueElementFilter(arrayElement, element);
      }).length > 0
    );
  };

  _elementDataExists = (subArrayPath, array, element) => {
    return (
      array.filter(arrayElement => {
        return this.subArrayUniqueDataElementFilter(
          subArrayPath,
          arrayElement,
          element
        );
      }).length > 0
    );
  };

  subArrayUniqueElementFilter = (arrayElement, element) => {
    return (
      (arrayElement.id && element.id && arrayElement.id === element.id) ||
      (!arrayElement.id && element.id) ||
      (arrayElement.id && !element.id) ||
      (!arrayElement.id && !element.id) ||
      this.subArrayUniqueDataElementFilter(arrayElement, element)
    );
  };

  subArrayUniqueDataElementFilter = (subArrayPath, arrayElement, element) => {
    return false;
  };

  removeFromSubArray = (subArrayPath, element) => {
    const { entity } = this.state;

    const filtered = CommonUtil.getDeep(entity, subArrayPath).filter(
      item => item.id !== element.id
    );

    this.resetFlags[subArrayPath] = false;

    this.setEntityProperty(subArrayPath, [...filtered]);
  };

  addToSubArray = (subArrayPath, element) => {
    const { entity } = this.state;

    const array = [...CommonUtil.getDeep(entity, subArrayPath)];

    if (this._elementDataExists(subArrayPath, array, element)) {
      return false;
    }

    array.push(element);

    this.resetFlags[subArrayPath] = false;

    this.setEntityProperty(subArrayPath, array);

    return true;
  };

  replaceInSubArray = (subArrayPath, element) => {
    const { entity } = this.state;

    const array = [...CommonUtil.getDeep(entity, subArrayPath)];

    if (this._elementDataExists(subArrayPath, array, element)) {
      return false;
    }

    //here Array.filter(...) must not be used because it creates new array
    for (let i = 0; i < array.length; i++) {
      if (array[i].id === element.id) {
        array[i] = { ...array[i] };
        CommonUtil.replaceObjectProperties(array[i], element, [
          "id",
          constants.NEW_ELEMENT_INDICATOR_PROPERTY
        ]);
      }
    }

    this.resetFlags[subArrayPath] = false;

    this.setEntityProperty(subArrayPath, array);

    return true;
  };

  _cleanNewSubArrayElements = entity => {
    for (let i = 0; i < this.getSubArraysPaths().length; i++) {
      const subArrayPath = this.getSubArraysPaths()[i];
      const array = CommonUtil.getDeep(entity, subArrayPath);

      if (array) {
        array.forEach(e => {
          if (e[constants.NEW_ELEMENT_INDICATOR_PROPERTY]) {
            const deletionProps =
              e.id && e.id > 0
                ? [constants.NEW_ELEMENT_INDICATOR_PROPERTY]
                : ["id", constants.NEW_ELEMENT_INDICATOR_PROPERTY];
            CommonUtil.deleteObjectProperties(e, deletionProps, false);
          }
        });
      }
    }
  };

  getSubArraysPaths = () => {
    throw new Error("You have to implement the method getSubArray!");
  };

  onEntitySave = () => {
    const entity = {
      ...this.state.entity
    };

    if (entity) {
      this._cleanNewSubArrayElements(entity);

      if (!entity.id) {
        this.saveNewEntity(entity);
      } else {
        this.updateEntity(entity);
      }
    }
  };

  saveNewEntity = entity => {
    throw new Error("You have to implement the method saveNewEntity!");
  };

  updateEntity = entity => {
    throw new Error("You have to implement the method updateEntity!");
  };

  setEntityProperty = (propertyName, propertyValue, isInitialSet = false) => {
    const { entity } = this.state;
    entity[propertyName] = CommonUtil.jsonCopy(propertyValue);

    if (CommonUtil.objectHasProperty(this.state, "oldEntity") && isInitialSet) {
      const { oldEntity } = this.state;
      oldEntity[propertyName] = CommonUtil.jsonCopy(propertyValue);

      this.setState({
        entity: entity,
        oldEntity: oldEntity
      });
    } else {
      this.setState({
        entity: entity,
        isChanged: true
      });
    }
  };

  renderProps() {
    return {
      ...super.renderProps(),
      entity: this.state.entity,
      onSave: this.onEntitySave,
      removeFromTable: this.removeFromSubArray,
      addToTable: this.addToSubArray,
      updateInTable: this.replaceInSubArray
    };
  }
}

export default SubControlComponent;
